<!--
 * @Author: 汪俊洪
 * @Date: 2025-04-27 10:41:05
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-06-06 11:42:50
 * @Description:
-->
<template>
  <div class="wrap">
    <div style="flex: 1; overflow: hidden">
      <el-table
        class="plc-table plc-table-checkbox"
        height="100%"
        :data="dataList"
        style="width: 100%"
        row-key="plcSkuId"
        ref="multipleTable"
        v-loading="dataListLoading"
        @selection-change="handleSelectionChange"
        :row-class-name="({ row }) => (row.used ? '' : 'row-disabled')"
      >
        <el-table-column
          type="selection"
          :selectable="(row) => row.used"
          align="center"
          width="55"
        >
        </el-table-column>
        <el-table-column
          prop="date"
          header-align="center"
          width="350px"
          label="商品信息"
        >
          <template slot-scope="scope">
            <div class="goods-info">
              <div>
                <el-image
                  class="fileUrls"
                  :src="scope.row.fileUrls"
                  :preview-src-list="[scope.row.fileUrls]"
                >
                </el-image>
                <span class="invalidStateSku" v-if="!scope.row.used"
                  >未上架</span
                >
              </div>
              <div class="goods-right">
                <h2 class="goodsName ell_two" @click="toGoodDetail(scope.row)">
                  {{ scope.row.goodsName }}
                </h2>
                <div class="plc-des">
                  <span class="plc-des-label">型号：</span>
                  <span class="plc-des-value">{{
                    scope.row.model || '-'
                  }}</span>
                </div>
                <div class="plc-des" v-if="activited === '4'">
                  <span class="plc-des-label">规格：</span>
                  <span class="plc-des-value">
                    <span>{{ scope.row.oldSpecification || '-' }}</span>
                  </span>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="brandName" align="center" label="品牌">
          <template slot-scope="scope">
            {{ scope.row.brandName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="skuCode" align="center" label="编码">
        </el-table-column>
        <el-table-column align="center" prop="sellingPrice" label="单价（元）">
          <template slot-scope="scope">
            ￥
            <span
              v-if="
                scope.row.activityType &&
                (scope.row.activityType == 1 || scope.row.activityType == 2)
              "
            >
              {{ scope.row.activityPrice | formatePrice }}</span
            >
            <span v-else>
              {{ scope.row.sellingPrice | formatePrice }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="sellingUnit" align="center" label="单位">
        </el-table-column>
        <el-table-column prop="goodsNum" align="center" label="数量">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              :content="`起订量${scope.row.moq || 1}, 步长${
                scope.row.sellingUnitStepSize || 1
              }`"
              v-if="scope.row.used"
            >
              <el-input-number
                size="mini"
                class="plc-input-number"
                v-model="scope.row.goodsNum"
                :min="1"
                style="width: 88px"
                :max="99999999"
                controls-position="right"
                @change="changeNum(scope.row)"
                :step="scope.row.sellingUnitStepSize || 1"
                :precision="0"
              ></el-input-number>
            </el-tooltip>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="sellingPrice"
          label="含税小计（元）"
          width="150px"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.used">
              <div
                class="show-money"
                v-if="
                  scope.row.activityType &&
                  (scope.row.activityType == 1 || scope.row.activityType == 2)
                "
              >
                <span v-if="activited === '4'">
                  {{ $t('common.currency')
                  }}{{
                    (scope.row.activityPrice * scope.row.goodsNum)
                      | formatePrice4
                  }}
                </span>
                <span v-else>
                  {{ $t('common.currency')
                  }}{{
                    (scope.row.activityPrice * scope.row.goodsNum)
                      | formatePrice
                  }}
                </span>
                <br />
              </div>
              <div class="show-money" v-else>
                <span v-if="activited === '4'">
                  {{ $t('common.currency')
                  }}{{
                    (scope.row.sellingPrice * scope.row.goodsNum)
                      | formatePrice4
                  }}
                </span>
                <span v-else>
                  {{ $t('common.currency')
                  }}{{
                    (scope.row.sellingPrice * scope.row.goodsNum) | formatePrice
                  }}
                </span>
              </div>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="model"
          label="操作"
          header-align="center"
          align="center"
          width="80px"
        >
          <template slot-scope="scope">
            <el-button
              type="danger"
              size="mini"
              plain
              @click="deleteHandle(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="plc-bottom">
      <!-- 底部内容1 -->
      <div class="plc-bottom1">
        <div class="btns">
          <el-checkbox
            v-model="allCheck"
            class="check-all"
            :disabled="!dataList.length || dataListLoading"
            @change="handleCheckAllChange"
            >全选</el-checkbox
          >
          <el-button
            type="text"
            @click="() => toDelSelected(multipleSelection)"
            :disabled="dataListLoading"
            class="del-btn"
          >
            删除选中商品
          </el-button>
          <el-button
            type="text"
            @click="toClearInvalid"
            :disabled="dataListLoading"
            class="del-btn"
          >
            删除未上架商品
          </el-button>
        </div>
        <div class="plc-bottom1-right">
          <div class="selected-num">
            已选择<span>{{ multipleSelection.length }}</span
            >种，共<span>{{ totalNum }}</span
            >件<span style="padding-left: 24px"></span>应付含税金额<span
              >￥{{ priceAmount }}</span
            >
          </div>
          <div @click="settlement" class="btn to-buy">
            {{ activited === '4' ? '领用' : '去结算' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatePrice } from '@/utils/formatePrice'
import { add } from '@/utils/numberComputed'
import debounce from 'lodash/debounce'
import { openOther } from '@/utils'

export default {
  props: {
    dataList: {
      type: Array,
      default: () => []
    },
    dataListLoading: {
      type: Boolean,
      default: false
    },
    activited: {
      type: String,
      default: '1'
    }
  },
  filters: {
    formatePrice (val) {
      if (val) {
        if (typeof val !== 'number') {
          val = val - 0
        }
        return formatePrice(val.toFixed(2))
      }
      if (val === null) {
        return '-'
      }
      return '0.00'
    }
  },
  data () {
    return {
      multipleSelection: [],
      totalNum: 0,
      priceAmount: 0,
      allCheck: false
    }
  },
  watch: {
    multipleSelection: {
      handler (val) {
        this.computedNum()
      },
      immediate: true
    }
  },
  methods: {
    // 表单提交
    changeNum: debounce(
      function (row) {
        const obj = {
          goodsNum: row.goodsNum,
          shoppingCartId: row.shoppingCartId
        }
        this.$http
          .post('/front/consumer/shoppingcart/updateShoppingCart', obj)
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.$message.success('操作成功')
              this.$emit('refresh')
            }
          })
      },
      700,
      { leading: false, trailing: true }
    ),
    // 底部全选
    handleCheckAllChange (val) {
      let multipleTable = this.$refs.multipleTable
      if (val) {
        multipleTable.toggleAllSelection()
      } else {
        multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      if (val.length && val.length === this.dataList.length) {
        this.allCheck = true
      } else {
        this.allCheck = false
      }
    },
    computedNum () {
      let totalNum = 0
      let priceAmount = 0
      this.multipleSelection.forEach((item) => {
        totalNum = add(totalNum, item.goodsNum)
        priceAmount = add(priceAmount, item.sellingPrice)
      })
      this.totalNum = totalNum
      this.priceAmount = priceAmount
    },
    // 删除选中商品
    toDelSelected (arr) {
      if (!arr.length) {
        return this.$message.warning('请选择要删除的商品')
      }
      this.$http
        .post(
          '/front/consumer/shoppingcart/deleteShoppingCart',
          arr.map((item) => item.shoppingCartId)
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$store.dispatch(
              'setShoppingCartCount',
              this.$store.state.shoppingCartCount + 1
            )
            this.$message.success('操作成功')
            this.$emit('refresh')
          }
        })
    },
    deleteHandle (item) {
      this.$http
        .post('/front/consumer/shoppingcart/deleteShoppingCart', [
          item.shoppingCartId
        ])
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$store.dispatch(
              'setShoppingCartCount',
              this.$store.state.shoppingCartCount + 1
            )
            this.$message.success('操作成功')
            this.$emit('refresh')
          }
        })
    },
    // 清空失效商品
    toClearInvalid () {
      this.toDelSelected(this.dataList.filter((i) => !i.used))
    },
    toGoodDetail (goods) {
      if (this.activited === '3' || this.activited === '4') {
        openOther(
          `sparePartsLibraryGoodDetail?spuId=${goods.goodsSpuId}&skuId=${goods.goodsSkuId}&custspId=${goods.custspId}`
        )
      } else if (this.activited === '5') {
        openOther(`courseDetail?id=${goods.goodsId}`)
      } else if (this.activited === '6') {
        // 选型
        openOther(`selectionInquiryDetail?spuId=${goods.spuId}`)
      } else {
        openOther(
          `goodDetail?spuId=${goods.goodsSpuId}&skuId=${goods.goodsSkuId}`
        )
      }
    },
    // 结算 跳转订单页面
    settlement () {
      if (this.dataListLoading) {
        return
      }
      if (!this.multipleSelection.length) {
        return this.$message.warning(this.$t('message.selectData'))
      }
      if (
        this.multipleSelection.some((item) => {
          const { sellingUnitStepSize, goodsNum, moq } = item
          const goodsName = item.goodsName || item.name
          const ret =
            goodsNum < (+moq || 1) ||
            goodsNum % (sellingUnitStepSize || 1) !== 0
          if (ret) {
            this.$message.warning(
              `【${goodsName}】起订量为${moq || 1}，步长为${
                sellingUnitStepSize || 1
              }，请输入大于${moq || 1}且${sellingUnitStepSize || 1}的倍数！`
            )
          }
          return ret
        })
      ) {
        return
      }

      let shoppingCartFormList = []
      this.multipleSelection.forEach((item) => {
        let dataList = this.dataList
        if (this.activited === '6') dataList = this.lectotypeList
        let row = dataList.find((ele) => {
          return ele.shoppingCartId === item.shoppingCartId
        })
        if (row) {
          if (this.activited === '1') {
            shoppingCartFormList.push({
              goodsSpuId: item.goodsSpuId,
              goodsSkuId: item.goodsSkuId,
              goodsNum: item.goodsNum,
              sellingPrice: item.sellingPrice,
              moq: item.moq || null,
              sellingUnitStepSize: item.sellingUnitStepSize || null
            })
          } else if (this.activited === '3') {
            // 备件需求
            shoppingCartFormList.push({
              oldGoodsCode: item.skuCode,
              oldGoodsName: item.goodsName,
              oldSpecification: item.oldSpecification,
              oldModel: item.model,
              oldBrand: item.brandName,
              oldRemark: '',
              safetyStockQuantityBef: 0,
              sellingUnit: item.sellingUnit,
              safetyStockQuantity: item.goodsNum,
              physicalUnitAmount: item.physicalUnitAmount,
              moq: item.moq || null,
              sellingUnitStepSize: item.sellingUnitStepSize || null
            })
          } else if (this.activited === '4') {
            console.log('领用', item)
            // 领用
            shoppingCartFormList.push({
              // goodsCode: '',
              // goodsName: '',
              // specification: '',
              // model: '',
              // remark: '',
              // goodsUrl: item.fileUrls,
              // edition: '',
              // congiguration: '',
              oldGoodsCode: item.skuCode,
              oldGoodsName: item.goodsName,
              oldSpecification: item.oldSpecification,
              oldModel: item.model,
              oldBrand: item.brandName,
              oldRemark: item.oldRemark,
              goodsNum: item.goodsNum,
              oldEdition: item.oldEdition,
              sellingUnit: item.sellingUnit,
              oldCongiguration: item.oldCongiguration,
              price: item.sellingPrice,
              // price: item.activityPrice || item.sellingPrice,
              // safetyStockQuantityBef: 0,
              safetyStockQuantity: item.safetyStockQuantity,
              custspId: item.custspId,
              physicalUnitAmount: item.physicalUnitAmount,
              moq: item.moq || null,
              sellingUnitStepSize: item.sellingUnitStepSize || null,
              skuId: item.skuId || item.goodsSkuId
            })
          } else if (this.activited === '6') {
            // 选型
            shoppingCartFormList.push(item.id)
          }
        }
      })
      if (this.activited === '1') {
        if (shoppingCartFormList.length) {
          // this.dataListLoading = true
          // 立即下单校验数量价格相关等
          this.$http
            .post(
              `/front/consumer/shoppingcart/checkCommodityPromotion`,
              shoppingCartFormList.map((item) => {
                return {
                  commodityId: item.goodsSkuId,
                  commodityNum: item.goodsNum
                }
              })
            )
            .then(({ data: res }) => {
              if (res.code !== 0) {
                this.$confirm(res.message, this.$t('prompt.title'), {
                  confirmButtonText: this.$t('confirm'),
                  showCancelButton: false,
                  type: 'warning'
                }).then(() => {})
                return false
              } else {
                // if (!this.$store.state.user.defaultCompanyId) {
                //   // 非企业用户先升级才可下单
                //   this.$confirm(
                //     this.$t('navbar.storeSpare1'),
                //     this.$t('prompt.title'),
                //     {
                //       dangerouslyUseHTMLString: true,
                //       confirmButtonText: this.$t('navbar.upgrade'),
                //       cancelButtonText: this.$t('cancel')
                //     }
                //   ).then(() => {
                //     this.addCompanyVisible = true
                //     this.$nextTick(() => {
                //       this.$refs.companyAdd.init()
                //     })
                //   })
                //   return false
                // }
                const t = new Date().getTime()
                const obj = {
                  t,
                  orderSource: '10',
                  shoppingCartFormList: shoppingCartFormList
                }
                sessionStorage.setItem('createOrder', JSON.stringify(obj))
                this.$router.push({
                  name: 'createOrder',
                  query: {
                    t
                  }
                })
              }
            })
            .finally(() => {
              // this.dataListLoading = false
            })
        }
      } else if (this.activited === '3') {
        this.$store.dispatch('setrequirementGoodsList', shoppingCartFormList)
        this.$router.push({
          name: 'spareRequirementsAdd',
          query: {
            getList: '1'
          }
        })
      } else if (this.activited === '4') {
        // 领用
        this.$store.dispatch('setLclbDataList', shoppingCartFormList)
        this.$router.push({
          name: 'spareGetAdd',
          query: {
            getList: 1
          }
        })
      } else if (this.activited === '6') {
        // 选型
        this.$router.push({
          name: 'selectionInquiryCreate',
          query: {
            shoppingCartFormList: JSON.stringify(shoppingCartFormList)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  ::v-deep .plc-input-number .el-input__inner {
    padding: 0 30px 0 4px;
  }
}
.goods-info {
  display: flex;
  align-items: center;
  .fileUrls {
    width: 131px;
    height: 131px;
    margin-right: 16px;
    img {
      object-fit: contain;
    }
  }
  .goodsName {
    font-size: 14px;
    font-weight: 700;
    color: #333333;
    margin: 0 0 14px;
    cursor: pointer;
    &:hover {
      color: #2a54d1;
      text-decoration: underline;
    }
  }
  .goods-right {
    flex: 1;
  }
}

.plc-des {
  text-align: left;
  margin-bottom: 9px;
}

.show-money {
  font-size: 20px;
  font-weight: 900;
  color: #e93037;
}

.plc-bottom {
  .plc-bottom1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 9.5px 16px;
    flex: 1;
  }
  .selected-num {
    font-size: 12px;
    color: #000;
    span {
      color: #ff0000;
    }
  }
  .plc-bottom1-right {
    display: flex;
    align-items: center;
    .btn {
      font-size: 18px;
      font-weight: bold;
      line-height: 20px;
      margin-left: 12px;
      padding: 8px 12px;
      background: #2a54d1;
      border-radius: 8px;
      color: #fff;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
      &.to-buy {
        background: #2a54d1;
      }
    }
  }
  .plc-pagination {
    border-top: 1px solid #eeeeee;
  }
  .del-btn {
    color: #ff4c2b;
    margin-left: 26px;
  }
}

.nowrap {
  white-space: nowrap;
}
</style>
